/**
 * @generated SignedSource<<586d96ced5752753108cb21fc8814ce3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TodoCategoryScreenFilter_employee$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"FilterButtonMe_employee">;
  readonly " $fragmentType": "TodoCategoryScreenFilter_employee";
};
export type TodoCategoryScreenFilter_employee$key = {
  readonly " $data"?: TodoCategoryScreenFilter_employee$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoCategoryScreenFilter_employee">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoCategoryScreenFilter_employee",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FilterButtonMe_employee"
    }
  ],
  "type": "Employee",
  "abstractKey": null
};

(node as any).hash = "e21fce9bb2ae2c6e39f7ecf3ebec7b7f";

export default node;
